import React, { Component, PropTypes } from 'react';
import EntryGallery from 'common/components/entry_gallery';
import { getDefaultViewType } from 'common/components/entry_gallery/view_type_selector';
import { getDefaultGrouping } from 'common/components/entry_gallery/grouping_selector';
import Pager from 'common/pager/containers';
import { hasAPIQueryStringChanged } from 'common/utils';
import Controls from 'profile/containers/your_entries/controls';
import { LoadingIndicator } from 'common/components/preloader';

export default class Entries extends Component {
  constructor(props) {
    super(props);

    this.fetch = this.fetch.bind(this);
  }

  fetch() {
    const { user, location, fetch } = this.props;
    fetch(user.id, location.query);
  }

  componentDidMount() {
    const { setViewType, setGrouping, entryType } = this.props;
    setViewType(getDefaultViewType(entryType));
    setGrouping(getDefaultGrouping());
    this.fetch();
  }

  componentDidUpdate(prevProps) {
    /* re-fetch resource if filter/sorting/search/etc query parameters have changed */
    if (hasAPIQueryStringChanged(this.props.resourceName, prevProps, this.props)) {
      this.fetch();
    }
  }

  componentWillUnmount() {
    this.props.clear();
  }

  render() {
    const {
      resourceName, entryType, entries, viewType, setViewType, setGrouping, grouped, loading
    } = this.props;

    return (
      <div className="row">
        <div className="columns small-16 large-12">
          { loading && <LoadingIndicator fullScreen={false} /> }
          { !loading &&
          <EntryGallery entryType={entryType} viewType={viewType}
            itemVariation="profileEntries" items={entries} grouped={grouped} /> }
          { !loading && <Pager resourceName={resourceName} /> }
        </div>
        <div className="columns small-16 large-4">
          <Controls />
        </div>
      </div>
    );
  }
}

Entries.propTypes = {
  user: PropTypes.object.isRequired,
  resourceName: PropTypes.string.isRequired,
  entryType: PropTypes.string.isRequired,
  entries: PropTypes.array.isRequired,
  viewType: PropTypes.string,
  grouped: PropTypes.bool,
  loading: PropTypes.bool.isRequired,
  fetch: PropTypes.func.isRequired,
  clear: PropTypes.func.isRequired,
  setViewType: PropTypes.func.isRequired,
  setGrouping: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./profile/components/your_entries/entries.jsx